import Location from '@/domain/Location'

export default class IDirectionsCalculator {
  constructor() {
    this.origin = null
    this.destination = null
  }

  setOrigin(location) {
    this.validateLocation(location)
    this.origin = location
  }

  setDestination(location) {
    this.validateLocation(location)
    this.destination = location
  }

  validateLocation(location) {
    if (location instanceof Location) {
      return
    }

    throw new Error('Invalid Location object')
  }

  async execute() {
    try {
      this.validateLocation(this.origin)
      this.validateLocation(this.destination)
      const directions = await this.calculateDirections()

      return directions
    } catch (error) {
      this.handleErrors(error)
    }
  }

  async calculateDirections() {}

  mapLocation(location) {}

  handleErrors(error) {
    console.log(error)
    throw error
  }
}
